var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"vuw-no-bullet vuw-msg"},_vm._l((_vm.getFormErrors(_vm.formKey)),function(error){return _c('li',{key:error.key},[_c('i',{staticClass:"far fa-exclamation-triangle"}),_c('span',[_vm._v(_vm._s(error.msg))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }